import React from 'react';
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import Tooltips from './Tooltips';

interface Props {
  data: any;
  phoneWidth?: number;
}

const BannersMosaic: React.FC<Props> = ({ data }) => {
  return (
    <Box
      w="100%"
      position="relative"
      _hover={{ bg: 'gray.200' }}
      backgroundColor="gray.100"
      borderRadius="6px"
      transition="150ms ease"
    >
      {data?.name ? (
        <>
          <Flex align="center" px={4}>
            <Text fontWeight="bold" fontSize="lg" mr={2}>
              {data?.name}
            </Text>
            <Tooltips data={data} />
          </Flex>
          {!!data?.description && (
            <Text fontSize="xs" color="gray.400" px={4}>
              {data.description}
            </Text>
          )}
        </>
      ) : (
        <Flex position="absolute" left={2} top={1}>
          <Tooltips data={data} />
        </Flex>
      )}

      <Flex mt={4}>
        {data?.items ? (
          <>
            {data?.type === 'second_line' ? (
              <>
                <Image
                  w="50%"
                  h="150px"
                  px={`${data.padding}px`}
                  src={data.items[0]?.file?.url || '/placeholder_product.jpg'}
                />
                <Flex
                  flexDirection="column"
                  w="50%"
                  borderWidth="1px"
                  borderColor="gray.400"
                  borderRadius="3px"
                >
                  <Image
                    w="100%"
                    h="75px"
                    px={`${data.padding}px`}
                    src={data.items[1]?.file?.url || '/placeholder_product.jpg'}
                  />
                  <Image
                    w="100%"
                    h="75px"
                    px={`${data.padding}px`}
                    src={data.items[2]?.file?.url || '/placeholder_product.jpg'}
                  />
                </Flex>
              </>
            ) : (
              <>
                <Flex
                  flexDirection="column"
                  w="50%"
                  borderWidth="1px"
                  borderColor="gray.400"
                  borderRadius="3px"
                >
                  <Image
                    w="100%"
                    h="75px"
                    px={`${data.padding}px`}
                    src={data.items[0]?.file?.url || '/placeholder_product.jpg'}
                  />
                  <Image
                    w="100%"
                    h="75px"
                    px={`${data.padding}px`}
                    src={data.items[1]?.file?.url || '/placeholder_product.jpg'}
                  />
                </Flex>
                <Image
                  w="50%"
                  h="150px"
                  px={`${data.padding}px`}
                  src={data.items[2]?.file?.url || '/placeholder_product.jpg'}
                />
              </>
            )}
          </>
        ) : (
          <Flex
            w="100%"
            h="150px"
            align="center"
            justify="center"
            borderWidth="3px"
            borderStyle="dashed"
            borderRadius="6px"
          >
            <Text color="gray.500">+ Adicionar</Text>
          </Flex>
        )}
      </Flex>
    </Box>
  );
};

export default BannersMosaic;
